import type { FC } from 'react'

import ConfirmPopover from '@app/shared/confirmPopover'
import { useStore } from '@app/store'

type Props = {
  recurringReportConfigurationId: string
}

const RecurringReportConfigurationDelete: FC<Props> = ({ recurringReportConfigurationId }) => {
  const deleteObject = useStore.use.deleteObject()

  const onSubmit = async () =>
    deleteObject({
      id: recurringReportConfigurationId,
      classType: 'recurringReportConfiguration'
    })

  return (
    <ConfirmPopover
      onConfirm={onSubmit}
      header="Delete recurring report"
      body="Are you sure you want to delete this recurring report? You won&#39;t be able to undo this."
      confirmButtonText="Delete recurring report"
    >
      Delete recurring report
    </ConfirmPopover>
  )
}

export default RecurringReportConfigurationDelete
